import { css } from "@emotion/react";

import * as colors from "@styles/emotion-styles/colors";

const header = css`
  display: flex;
  border-bottom: 1px solid ${colors.grey.lightFamily.normal};
  padding: 1rem;
`;

const logo = css`
  display: flex;
  flex: 1;
  max-width: 6.5rem;
  max-height: 2.5rem;
`;

export const fsLogo = css`
  ${logo}
  margin-right: 1rem;
`;

export const partnerLogo = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const partnerLogoContainer = css`
  ${logo}
  padding-left: 1rem;
  border-left: 1px solid ${colors.grey.lightFamily.dark};
`;

export { header };
